import { Calendar, Search } from "lucide-react";
import { FC, useEffect, useState } from "react";
import { useTaskStore } from "./task.store";
import { useDebounceValue } from "~/hooks/use-debounce";
import { DatePicker } from "antd";

type Props = {};

export const TaskFilters: FC<Props> = () => {
  const [searchTerm, setSearchTerm] = useState("");

  const [search] = useDebounceValue(searchTerm, 500);
  const { filters, setFilters } = useTaskStore();

  useEffect(() => {
    setFilters({ search });
  }, [search, setFilters]);

  return (
    <>
      {/* View Toggle */}
      <div className="bg-white rounded-lg border p-4 mb-6 shadow-sm">
        <div className="flex items-center justify-between">
          <div className="flex space-x-4">
            <button className="px-4 py-2 rounded-lg bg-blue-100 text-blue-700">
              List View
            </button>
            <button className="px-4 py-2 rounded-lg hover:bg-gray-100">
              Calendar View
            </button>
          </div>

          <div className="flex items-center space-x-4">
            <div className="flex items-center space-x-2">
              <Calendar size={16} className="text-gray-400" />
              <DatePicker
                value={filters.dueDate}
                onChange={(dueDate: Date) => {
                  setFilters({ dueDate });
                }}
                className="border rounded-lg p-2"
              />
            </div>
            <select
              value={filters.status}
              onChange={(e) => setFilters({ status: e.target.value })}
              className="border rounded-lg p-2"
            >
              <option value="">All Tasks</option>
              <option value="COMPLETED">Completed</option>
              <option value="IN_PROGRESS">In Progress</option>
              <option value="PENDING">Pending</option>
            </select>
          </div>
        </div>
      </div>

      {/* Search */}
      <div className="bg-white rounded-lg border p-4 mb-6 shadow-sm">
        <div className="relative">
          <input
            type="text"
            className="w-full pl-10 pr-4 py-2 border rounded-lg"
            placeholder="Search tasks..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
          <Search className="absolute left-3 top-2.5 text-gray-400" size={16} />
        </div>
      </div>
    </>
  );
};
